import React, { useRef, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import { ICON_SAVE, ICON_CANCEL } from '../../../../extras/icons';
import ButtonSpinner from '../../../../layout/ButtonSpinner';
//Redux
import { useDispatch } from 'react-redux';
import { updateAccusedAction } from '../../../../../actions/audiencesActions';
//Función principal
const AccusedEditForm = props => {
    //Tomo los props
    const { show, handleClose, audience, accused } = props;
    //Genero los ref
    const refApellido = useRef();
    //Inicializo datos
    const initialData = {
        apellido: accused.persona ? accused.persona.apellido : '',
        nombre: accused.persona ? accused.persona.nombre : '',
        tipo_documento: accused.persona ? accused.persona.tipoDocumento : '',
        nro_documento: accused.persona ? accused.persona.identificacion : '',
        domicilio: accused.domicilio ? accused.domicilio : '',
        telefono: accused.telefono ? accused.telefono : '',
        email: accused.email ? accused.email : ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Inicializo el state local
    const [loading, setLoading] = useState(false);
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refApellido.current.focus();
    }
    //Manejo el guardado
    const handleSave = values => {
        //Armo la data
        const data = {
            ...accused,
            /*defensoria: values.defensoria && values.defensoria !== '' ? {
                id: values.defensoria
            } : null,
            dependencia: values.dependencia && values.dependencia !== '' ? {
                id: values.dependencia
            } : null,
            detenido: values.detenido,*/
            domicilio: values.domicilio,
            email: values.email,
            //fecha_detencion: values.fecha_detencion,
            //fecha_vencimiento: values.fecha_vencimiento,
            /*menor: values.menor,
            menores: values.menores && values.menores !== '' ? {
                id: values.menores
            } : null,
            particular: [{
                matricula: '',
                cuit: '',
                domicilio: '',
                email: '',
                telefono: ''
            }],*/
            particular: accused.imputadoParticularesList,
            persona: {
                apellido: values.apellido,
                nombre: values.nombre,
                tipo_documento: values.tipo_documento,
                nro_documento: values.nro_documento
            },
            telefono: values.telefono
        }
        //Llamo al dispatch
        dispatch( updateAccusedAction(accused, data, handleClose) );
    }
    //Esquema de validación
    const validationSchema = yup.object({
        apellido: yup.string().required(),
        nombre: yup.string().required(),
        tipo_documento: yup.string().required(),
        nro_documento: yup.string().required(),
        domicilio: yup.string().required(),
        telefono: yup.string().nullable(),
        email: yup.string().email().nullable()
    });
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Editar Imputado <small>(Audiencia #{ audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...initialData }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        A continuación puede editar los campos del Imputado
                                    </div>
                                </div>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        id="apellido"
                                        className="form-control" 
                                        autoFocus 
                                        name="apellido" 
                                        type="text" 
                                        placeholder="Ingrese apellido"
                                        value={ values.apellido }
                                        onChange={handleChange}
                                        isInvalid={!!errors.apellido}
                                        disabled={ loading }
                                        ref={refApellido}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.apellido }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        id="nombre"
                                        className="form-control" 
                                        name="nombre" 
                                        type="text" 
                                        placeholder="Ingrese nombre"
                                        value={ values.nombre }
                                        onChange={handleChange}
                                        isInvalid={!!errors.nombre}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nombre }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as="select"
                                        id="tipo_documento"
                                        className="form-control"  
                                        name="tipo_documento" 
                                        type="text" 
                                        value={ values.tipo_documento }
                                        onChange={handleChange}
                                        isInvalid={!!errors.tipo_documento}
                                        disabled={ loading }
                                    >
                                        <option value="">Tipo documento...</option>
                                        <option value="">Tipo documento</option>
                                        <option value="DNI">DNI</option>
                                        <option value="CUIT">CUIT/CUIL</option>
                                        <option value="PASAPORTE">PASAPORTE</option>
                                        <option value="MATRICULA">MATRICULA</option>
                                        <option value="LC">L.C.</option>
                                        <option value="LE">L.E.</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tipo_documento }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        id="nro_documento"
                                        className="form-control" 
                                        name="nro_documento" 
                                        type="text" 
                                        placeholder="No. documento"
                                        value={ values.nro_documento }
                                        onChange={handleChange}
                                        isInvalid={!!errors.nro_documento}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nro_documento }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        id="domicilio"
                                        className="form-control" 
                                        name="domicilio" 
                                        type="text" 
                                        placeholder="Ingrese domicilio"
                                        value={ values.domicilio }
                                        onChange={handleChange}
                                        isInvalid={!!errors.domicilio}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.domicilio }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <Form.Control
                                        id="telefono"
                                        className="form-control" 
                                        name="telefono" 
                                        type="text" 
                                        placeholder="Ingrese teléfono"
                                        value={ values.telefono }
                                        onChange={handleChange}
                                        isInvalid={!!errors.telefono}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.telefono }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-8">
                                    <Form.Control
                                        id="email"
                                        className="form-control" 
                                        name="email" 
                                        type="text" 
                                        placeholder="Ingrese email"
                                        value={ values.email }
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.email }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>ACTUALIZAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default AccusedEditForm;